import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { DrawerReportCommonFiltersCP } from 'main/modules/reports/components/reports-common-filters/DrawerReportCommonFiltersCP'
import { useFormStateManager } from 'main/common/form-state-manager/UseFormStateManager'
import { ReportsCommonFiltersFormModel } from 'main/modules/reports/components/reports-common-filters/inner/ReportsCommonFiltersFormModel'
import { HeaderCP } from 'submodules/nerit-framework-ui/common/components/screen/layout/header/HeaderCP'
import { HeaderButtonICP } from 'main/common/components/screen-layout/header/inner/HeaderButtonICP'
import { AppStateUtils } from 'main/common/utils/AppStateUtils'
import { SystemUtils } from 'main/common/utils/SystemUtils'
import { TableAppointmentsCP } from 'main/modules/scheduler/components/table-appointments/TableAppointmentsCP'

/**
 * Relatorio de Agenda do Dia.
 */
export function ScreenContentSchedulerListReportCP(): JSX.Element {

    const [isFilterDrawerVisible, setIsFilterDrawerVisible] = useState<boolean>(false)

    const [formValidator, setFormValidator] = useState<ReportsCommonFiltersFormModel>((new ReportsCommonFiltersFormModel()))
    const formStateManager = useFormStateManager<ReportsCommonFiltersFormModel>(formValidator)

    const [shouldLoadReport, setShouldLoadReport] = useState<boolean>(false)

    useEffect(() => { init() }, [])

    /**
     * Inicializa definindo os filtros iniciais.
     */
    async function init(): Promise<void> {

        setFormValidator(new ReportsCommonFiltersFormModel({
            dateRange: {
                beginDate: new Date(),
                endDate: new Date()
            },
            franchisesCodes: AppStateUtils.getCurrentFranchise()!.isFranchisor ? undefined : [AppStateUtils.getCurrentFranchise()!.code]
        }))

        // Necessario para o sincronismo entre setar os filtros default e chamar a query com os filtros setadas
        await SystemUtils.sleep(10)
        setShouldLoadReport(true)
    }

    return (
        <>
            <HeaderCP title={'Agenda do Dia'}>
                <HeaderButtonICP
                    onClick={() => setIsFilterDrawerVisible(!isFilterDrawerVisible)}
                    icon={'filter'}
                    label={'Filtros'}
                />
            </HeaderCP>

            <ContentWrapperSCP>
                <ContentSCP>
                    <TableAppointmentsCP
                        filterStateManager={formStateManager}
                        shouldReloadReport={shouldLoadReport}
                        onReportLoaded={() => setShouldLoadReport(false)}
                    />
                </ContentSCP>
            </ContentWrapperSCP>

            <DrawerReportCommonFiltersCP
                formStateManager={formStateManager}
                fieldsConfig={{ showUserAttendance: true, showScheduleStatus: true, showEvaluationsFilter: true }}
                visible={isFilterDrawerVisible}
                onClearFilters={() => setFormValidator(new ReportsCommonFiltersFormModel({}))}
                onFilter={() => setShouldLoadReport(true)}
                onClose={() => setIsFilterDrawerVisible(false)}
                loading={shouldLoadReport}
            />
        </>
    )
}

const ContentSCP = styled.div`
  width: 100%;
`

const ContentWrapperSCP = styled.div`
    display: flex;
    overflow-x: auto;
    justify-content: center;
`
